import { createContext } from "react"
export const store = createContext(null);
export const initialState = {
    title:'',
    subtitle:''
}
export function reducer(state,actions){
    const {payload,type} = actions;
    switch (type) {
        case 'CHANGE_TITLE_SUBTITLE':
            return {...state,title:payload?.title||"",subtitle:payload?.subtitle||''};
        default:
            return {...state};
    }
}